import { TFunction } from "i18next";

// Used as arguments for FormFieldWithCustomInput
export const getTrainCustomInputs = (
  translate: TFunction<"translation", undefined>,
) =>
  ({
    event: {
      label: `${translate("Hendelse", { count: 1 })}*`,
      typeFormField: "trainForm.type",
      severityFormField: "trainForm.severity",
      customFormField: "trainForm.distributions.texts",
    },

    reason: {
      label: `${translate("Årsak")}*`,
      typeFormField: "trainForm.reason.type",
      customFormField: "trainForm.reason.description",
    },

    action: {
      label: translate("Handling"),
      typeFormField: "trainForm.action.type",
      customFormField: "trainForm.action.description",
    },

    prognosisType: {
      label: translate("Prognose"),
      typeFormField: "trainForm.prognosisType.type",
      customFormField: "trainForm.prognosisType.description",
    },
  }) as const;

// Used as arguments for FormFieldWithCustomInput
export const getInfrastructureCustomInputs = (
  translate: TFunction<"translation", undefined>,
) =>
  ({
    type: {
      label: `${translate("Hendelse", { count: 1 })}*`,
      typeFormField: "infrastructureForm.type",
      severityFormField: "infrastructureForm.severity",
      customFormField: "infrastructureForm.distributions.texts",
    },

    consequence: {
      label: translate("Konsekvens"),
      typeFormField: "infrastructureForm.consequence.type",
      customFormField: "infrastructureForm.consequence.description",
    },

    prognosisType: {
      label: translate("Prognose"),
      typeFormField: "infrastructureForm.prognosisType.type",
      customFormField: "infrastructureForm.prognosisType.description",
    },

    reason: {
      label: `${translate("Årsak")}*`,
      typeFormField: "infrastructureForm.reason.type",
      customFormField: "infrastructureForm.reason.description",
    },

    action: {
      label: translate("Handling"),
      typeFormField: "infrastructureForm.action.type",
      customFormField: "infrastructureForm.action.description",
    },
  }) as const;

// Used as arguments for FormFieldWithCustomInput
export const getStationCustomInputs = (
  translate: TFunction<"translation", undefined>,
) =>
  ({
    event: {
      label: translate("Hendelse", { count: 1 }),
      typeFormField: "stationForm.stationInformationType",
      severityFormField: "stationForm.severity",
      customFormField: "stationForm.distributions.texts",
    },
  }) as const;
